import { createServiceAction } from '../util/actionHelper.js';

export const getUserNotifyAct = createServiceAction(
  'userNotifyData',
  'requested'
);
